import React from "react";
import { Typography } from "@material-ui/core";
import intl from "react-intl-universal";

import { IMiniUser } from "types";
import { RawSelectField as SelectField } from "components/SelectField";
import {
  STATS,
  EVENT_VALUES,
  STAT_RESULT_OPTIONS,
  STAT_POSSESSION_OPTIONS,
} from "modules/withball-data-input/constants";

interface IEventFilterProps {
  players: IMiniUser[];
  disablePlayerFilter?: boolean;
  onPlayerChange: (playerIds: number[]) => void;
  onEventCategoryChange: (eventCategories: number[]) => void;
  onEventResultChange: (eventResults: boolean[]) => void;
  onEventPossessionChange: (eventPossessions: string[]) => void;
}

export const EventFilter = ({
  players,
  disablePlayerFilter = false,
  onPlayerChange,
  onEventCategoryChange,
  onEventResultChange,
  onEventPossessionChange,
}: IEventFilterProps) => {
  const playerOptions: any[] = players.map((player) => ({
    label: player.name,
    value: player.id,
  }));

  const statsOptions: any[] = STATS.map((stat) => ({
    label: intl.get(stat.i18nTag),
    value: EVENT_VALUES[stat.name],
  }));

  const resultOptions: any[] = STAT_RESULT_OPTIONS.map((res) => ({
    label: intl.get(res.i18nTag),
    value: res.value,
  }));

  const possessionOptions: any[] = STAT_POSSESSION_OPTIONS.map((pos) => ({
    label: intl.get(pos.i18nTag),
    value: pos.value,
  }));

  const handlePlayerChange = (selectedOptions: any) => {
    onPlayerChange(selectedOptions?.map((option: any) => option.value) || []);
  };

  const handleEventCategoryChange = (selectedOptions: any) => {
    onEventCategoryChange(
      selectedOptions?.map((option: any) => option.value) || []
    );
  };

  const handleEventResultChange = (selectedOptions: any) => {
    onEventResultChange(
      selectedOptions?.map((option: any) => option.value) || []
    );
  };

  const handleEventPossessionChange = (selectedOptions: any) => {
    onEventPossessionChange(
      selectedOptions?.map((option: any) => option.value) || []
    );
  };

  return (
    <>
      {!disablePlayerFilter && (
        <>
          <Typography variant="subtitle1">
            {intl.get("MATCH_DASHBOARD_STATS_SELECT_SELECT_PLAYERS")}
          </Typography>
          <SelectField
            isMulti
            options={playerOptions}
            onChange={handlePlayerChange}
          />
        </>
      )}
      <Typography variant="subtitle1">
        {intl.get("MATCH_DASHBOARD_STATS_SELECT_SELECT_ACTIONS")}
      </Typography>
      <SelectField
        isMulti
        options={statsOptions}
        onChange={handleEventCategoryChange}
      />
      <Typography variant="subtitle1">
        {intl.get("MATCH_DASHBOARD_STATS_SELECT_SELECT_RESULTS")}
      </Typography>
      <SelectField
        isMulti
        options={resultOptions}
        onChange={handleEventResultChange}
      />
      <Typography variant="subtitle1">
        {intl.get("MATCH_DASHBOARD_STATS_SELECT_SELECT_POSSESSION_STATUS")}
      </Typography>
      <SelectField
        isMulti
        options={possessionOptions}
        onChange={handleEventPossessionChange}
      />
    </>
  );
};
